export default __webpack_public_path__ + "static/media/win.c30e2641.mp3";